import PropTypes from "prop-types";
import React from "react";
import CodeSample from "../../components/CodeSample";
import PartPreview from "../../components/PartPreview";
import { getPart } from "../../util/parts";
import "./Part.css";

class Part extends React.Component {
  constructor(props) {
    super(props);
    const { username, partName } = props.match.params;
    this.state = {
      username,
      partName,
      loaded: false,
      part: {},
    };
  }

  componentDidMount() {
    getPart(this.state.username, this.state.partName)
      .then(part => this.setState({ part, loaded: true }))
      .catch(() => this.setState({ part: {}, loaded: true }));
  }

  render() {
    const { loaded, part, username, partName } = this.state;
    const partExists = !loaded || part.name;
    return (
      <div>
        <div className="partList">
          <div className="partBanner">
            <h1>{partName}</h1>
          </div>
          {partExists ? (
            loaded && (
              <div className="partDisplay">
                <PartPreview
                  key={part.createdAt}
                  name={part.name}
                  createdBy={part.createdBy}
                  sequence={part.sequence}
                />
                <p>
                  To clone this part,{" "}
                  <a href="https://github.com/gndrv/gndrv">download the CLI</a>{" "}
                  and run
                </p>
                <CodeSample>gndrv clone {`${username}/${partName}`}</CodeSample>
              </div>
            )
          ) : (
            <h3>{`${username}/${partName}`} does not exist.</h3>
          )}
        </div>
      </div>
    );
  }
}

Part.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string,
      partName: PropTypes.string,
    }),
  }).isRequired,
};

export default Part;



// WEBPACK FOOTER //
// ./src/pages/Part/Part.js